import React, { useEffect, useMemo, useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";
export const Card = ({ item }) => {
  return (
    <div className="item-card">
      <div className="item-card-content">
        <div className="item-card-title">{item.title}</div>
        <div className="item-card-subtitle">{item.subtitle}</div>
        {item.lists.map((list, index) => (
          <div>
            <div className="item-card-list-title">{list.title}</div>
            <div className="item-card-list-subtitle">{list.subtitle}</div>
          </div>
        ))}
      </div>
      <div className="item-card-img">
        <img src={item.img} alt="authing" />
      </div>
    </div>
  );
};

export const AuthorityCustomer = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    // eslint-disable-next-line no-undef
    new Swiper(".swiper-container", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      direction: "vertical",
      effect: "coverflow",
      slidesPerView: 4,
      spaceBetween: "-60%",
      loop: true,
      centeredSlides: true,
      autoplay: true,
      coverflowEffect: {
        rotate: 0,
        modifier: 3,
        slideShadows: false,
        stretch: -162,
        depth: 500,
      },
    });
  }, []);
  const productLists = useMemo(() => {
    return [
      {
        title: t("authority.model.rbac.title"),
        subtitle: t("authority.model.rbac.subtitle"),
        img: `//files.authing.co/authing-website/${t(
          "authority.model.rbac.img"
        )}`,
        lists: [
          {
            title: t("authority.model.rbac.item1.title"),
            subtitle: t("authority.model.rbac.item1.subtitle"),
          },
          {
            title: t("authority.model.rbac.item2.title"),
            subtitle: t("authority.model.rbac.item2.subtitle"),
          },
          {
            title: t("authority.model.rbac.item3.title"),
            subtitle: t("authority.model.rbac.item3.subtitle"),
          },
        ],
      },

      {
        title: t("authority.model.abac.title"),
        subtitle: t("authority.model.abac.subtitle"),
        img: `//files.authing.co/authing-website/${t(
          "authority.model.abac.img"
        )}`,
        lists: [
          {
            title: t("authority.model.abac.item1.title"),
            subtitle: t("authority.model.abac.item1.subtitle"),
          },
          {
            title: t("authority.model.abac.item2.title"),
            subtitle: t("authority.model.abac.item2.subtitle"),
          },
          {
            title: t("authority.model.abac.item3.title"),
            subtitle: t("authority.model.abac.item3.subtitle"),
          },
        ],
      },
    ];
  }, [t]);
  return (
    <div>
      <section className="authority-customer">
        <div className="inner">
          <div className="title">{t("authority.model.title")}</div>
          <div className="subtitle">{t("authority.model.subtitle")}</div>
          <div className="swiper">
            <div className="swiper-container">
              <div class="swiper-wrapper">
                {productLists.map((item, index) => {
                  return (
                    <div class="swiper-slide" key={`item-${index}`}>
                      <Card item={item} />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="arrow-icon-outer-prev swiper-button-prev">
              <div className="arrow-icon-outer">
                <div className="arrow-icon-inner">
                  <i className="icon authing-icon authing-arrow-left-s-line"></i>
                </div>
              </div>
            </div>
            <div className="arrow-icon-outer-next swiper-button-next">
              <div className="arrow-icon-outer">
                <div className="arrow-icon-inner">
                  <i className="icon authing-icon authing-arrow-right-s-line"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
